const currencyList = [
  { name: 'HKD', value: 'HKD', iso: 344, currencySymbol: 'HK$' },
  { name: 'USD', value: 'USD', iso: 840, currencySymbol: '$' },
  { name: 'GBP', value: 'GBP', iso: 826, currencySymbol: '￡' },
  { name: 'EUR', value: 'EUR', iso: 978, currencySymbol: '€' },
  { name: 'CAD', value: 'CAD', iso: 124, currencySymbol: 'C$' },
  { name: 'AUD', value: 'AUD', iso: '036', currencySymbol: 'A$' },
  { name: 'SGD', value: 'SGD', iso: 702, currencySymbol: 'S$' },
  { name: 'CNY', value: 'CNY', iso: 156, currencySymbol: '￥' },
  { name: 'MYR', value: 'MYR', iso: 458, currencySymbol: 'RM' },
  { name: 'JPY', value: 'JPY', iso: 392, currencySymbol: '￥' },
  { name: 'KRW', value: 'KRW', iso: 410, currencySymbol: '₩' },
  { name: 'TWD', value: 'TWD', iso: 901, currencySymbol: 'NT$' },
  { name: 'PHP', value: 'PHP', iso: 608, currencySymbol: '₱' }
]

const currencyMap = {}
currencyList.forEach(item => {
  currencyMap[item.iso] = item.currencySymbol
})

export {
  currencyList,
  currencyMap
}
